// Sun Valley : retrait en boutique choisi depuis la fiche produit (tiroir « Disponibilité en boutique »).
// La boutique est mémorisée en attribut de panier « Retrait en boutique » (visible dans la commande) ;
// le tiroir panier l'affiche et permet de revenir à la livraison. Le choix final du mode de livraison
// reste celui du checkout Shopify (niveau 1 de l'omnicanalité, Enzo, 14/09/2026).
(() => {
  const racine = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const rafraichir = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  window.svRetrait = {
    // Mémorise la boutique de retrait sur le panier
    async choisir(nom, ville, emplacement) {
      const r = await fetch(`${racine()}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Retrait en boutique': `${nom}, ${ville}`, _boutique_retrait_id: String(emplacement || '') } }),
      });
      return r.ok;
    },
    async retirer() {
      const r = await fetch(`${racine()}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Retrait en boutique': '', _boutique_retrait_id: '' } }),
      });
      if (r.ok) rafraichir();
      return r.ok;
    },
  };

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sv-retrait-livraison]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    await window.svRetrait.retirer();
  });
})();
